var _rect, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 2.7998,
    width: 18,
    height: 16.2,
    rx: 1.35,
    stroke: "#8390A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.95 1V4.6",
    stroke: "#8390A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0516 1V4.6",
    stroke: "#8390A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99844 10.8992C10.744 10.8992 11.3484 10.2948 11.3484 9.54922C11.3484 8.80363 10.744 8.19922 9.99844 8.19922C9.25285 8.19922 8.64844 8.80363 8.64844 9.54922C8.64844 10.2948 9.25285 10.8992 9.99844 10.8992Z",
    fill: "#8390A1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9516 10.8992C15.6971 10.8992 16.3016 10.2948 16.3016 9.54922C16.3016 8.80363 15.6971 8.19922 14.9516 8.19922C14.206 8.19922 13.6016 8.80363 13.6016 9.54922C13.6016 10.2948 14.206 10.8992 14.9516 10.8992Z",
    fill: "#8390A1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.04922 15.8484C5.7948 15.8484 6.39922 15.244 6.39922 14.4984C6.39922 13.7529 5.7948 13.1484 5.04922 13.1484C4.30363 13.1484 3.69922 13.7529 3.69922 14.4984C3.69922 15.244 4.30363 15.8484 5.04922 15.8484Z",
    fill: "#8390A1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99844 15.8484C10.744 15.8484 11.3484 15.244 11.3484 14.4984C11.3484 13.7529 10.744 13.1484 9.99844 13.1484C9.25285 13.1484 8.64844 13.7529 8.64844 14.4984C8.64844 15.244 9.25285 15.8484 9.99844 15.8484Z",
    fill: "#8390A1"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.6670da76.svg";
export { ForwardRef as ReactComponent };